export const FISCAL_STATUS = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  PENDING: 'PENDING_FISCAL',
  FISCALIZED: 'FISCALIZED',
  FAILED: 'FISCAL_FAILED',
};
